import { Outlet } from "react-router";
import OverlayGredientColor from "../../layouts/OverlayGredientColor";
import Sidebar from "../components/sideComponent/Sidebar";
import FacebookAdCard from "../../../widgets/community/ads/FacebookAdCard";
import BlackMarketRates from "../../../widgets/market/BlackMarketRates";
import TopNavigation from "./TopNavigation";

function CommunityLayout() {
  return (
    <main className="min-h-screen bg-background">
      <OverlayGredientColor />

      {/* Mobile */}
      <div className="lg:hidden pt-24">
      <TopNavigation />

        <div className="container mx-auto px-4 pt-4">
          <Outlet />
        </div>
      </div>

      {/* Desktop */}
      <div className="hidden lg:block py-40">
        <div className="mx-auto max-w-[1440px]">
          <div className="grid grid-cols-[280px_minmax(0,1fr)_320px] gap-6 px-6">
            {/* Left */}
            <aside className="relative">
              <div className="fixed top-40 w-[280px] z-0">
                <div className="max-h-1/1 overflow-y-auto p-0">
                  <Sidebar />
                </div>
              </div>
            </aside>

            {/* Center */}
            <main className="min-w-0">
              <Outlet />
            </main>

            {/* Right */}
            <aside className="relative">
              <div className="fixed top-40 w-[320px] z-0">
                <div className="max-h-[calc(100vh-7rem)] overflow-y-auto space-y-6 pr-2">
                  <FacebookAdCard
                    ad={{
                      image:
                        "https://images.deepai.org/art-image/70fc331d01aa433b930e31b7f600194b/a-simple-dummy-image-abstract-colors-minimal-design.jpg",
                      headline: "Create more than a website",
                      domain: "godaddy.com",
                      link: "https://www.godaddy.com",
                    }}
                  />

                  <FacebookAdCard
                    ad={{
                      image:
                        "https://images.deepai.org/art-image/70fc331d01aa433b930e31b7f600194b/a-simple-dummy-image-abstract-colors-minimal-design.jpg",
                      headline:
                        "اشحن حساب جوجل الإعلاني الان بالجنية المصري",
                      domain: "convertedpay.convertedin.com",
                      link: "https://convertedpay.convertedin.com",
                      language: "rtl",
                    }}
                  />

                  <BlackMarketRates />
                </div>
              </div>
            </aside>
          </div>
        </div>
      </div>
    </main>
  );
}

export default CommunityLayout;